// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 11303-根据id删除role POST /web/v1/role/delete/${param0} */
export async function deleteSwimRole(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteSwimRoleParams,
  options?: { [key: string]: any }
) {
  const { roleId: param0, ...queryParams } = params;
  return request<API.YmResultVOString>(`/web/v1/role/delete/${param0}`, {
    method: "POST",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 11305-根据id禁用role POST /web/v1/role/disable/${param0} */
export async function disableSwimRole(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.disableSwimRoleParams,
  options?: { [key: string]: any }
) {
  const { roleId: param0, ...queryParams } = params;
  return request<API.YmResultVOString>(`/web/v1/role/disable/${param0}`, {
    method: "POST",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 11304-根据id启用role POST /web/v1/role/enable/${param0} */
export async function enableSwimRole(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.enableSwimRoleParams,
  options?: { [key: string]: any }
) {
  const { roleId: param0, ...queryParams } = params;
  return request<API.YmResultVOString>(`/web/v1/role/enable/${param0}`, {
    method: "POST",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 11306-查询角色的列表(简易返回) POST /web/v1/role/listWithPage */
export async function getSwimCommonRolePageList(
  body: API.SwimRoleCommonPageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOCommonVo>(
    "/web/v1/role/listWithPage",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 11301-分页查询role POST /web/v1/role/pageList */
export async function webGetSwimRolePageList(
  body: API.SwimRolePageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimRoleBasicVo>(
    "/web/v1/role/pageList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 11302-新增/更新role POST /web/v1/role/upsert */
export async function upsertSwimRole(
  body: API.SwimRoleBasicVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOString>("/web/v1/role/upsert", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
